// import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
// import { useUser } from './UserContext';
// import ApiService from './ApiService';

// const apiService = new ApiService();

// // Create the context
// const StatsContext = createContext(undefined);

// // Provider component that wraps your app and makes stats accessible everywhere
// export const StatsProvider = ({ children }) => {
//   const { userId, language } = useUser();
//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [lastFetchTime, setLastFetchTime] = useState(null);

//   // Fetch stats function
//   const fetchStats = useCallback(async (forceRefresh = false) => {
//     // Don't fetch if we don't have userId or language
//     if (!userId || !language) {
//       setLoading(false);
//       return;
//     }

//     // If we recently fetched (within 30 seconds) and not forcing refresh, skip
//     const now = Date.now();
//     if (!forceRefresh && lastFetchTime && (now - lastFetchTime < 30000)) {
//       return;
//     }

//     try {
//       setLoading(true);
//       setError(null);
      
//       console.log('Fetching user statistics...');
//       const data = await apiService.fetchUserStatistics({ 
//         user_id: userId, 
//         language 
//       });
      
//       console.log('Stats fetched successfully:', data);
//       setStats(data);
//       setLastFetchTime(now);
//     } catch (err) {
//       console.error('Error fetching user statistics:', err);
//       setError(err.message || 'Failed to fetch statistics');
//     } finally {
//       setLoading(false);
//     }
//   }, [userId, language, lastFetchTime]);

//   // Fetch stats on mount and when userId/language changes
//   useEffect(() => {
//     fetchStats();
//   }, [userId, language]); // Intentionally not including fetchStats to avoid infinite loop

//   // Function to manually refresh stats (useful after completing exercises)
//   const refreshStats = useCallback(() => {
//     return fetchStats(true);
//   }, [fetchStats]);

//   const value = {
//     stats,
//     loading,
//     error,
//     refreshStats
//   };

//   return (
//     <StatsContext.Provider value={value}>
//       {children}
//     </StatsContext.Provider>
//   );
// };

// // Custom hook to use the stats context
// export const useStats = () => {
//   const context = useContext(StatsContext);
//   if (context === undefined) {
//     throw new Error('useStats must be used within a StatsProvider');
//   }
//   return context;
// };




import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import { useUser } from './UserContext';
import ApiService from './ApiService';

const apiService = new ApiService();

// Create the context
const StatsContext = createContext(undefined);

// Provider component that wraps your app and makes stats accessible everywhere
export const StatsProvider = ({ children }) => {
  const { userId, language } = useUser();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const lastFetchTimeRef = useRef(null);

  // Fetch stats function
  const fetchStats = useCallback(async (forceRefresh = false) => {
    // Don't fetch if we don't have userId or language
    if (!userId || !language) {
      setLoading(false);
      return;
    }

    // If we recently fetched (within 30 seconds) and not forcing refresh, skip
    const now = Date.now();
    if (!forceRefresh && lastFetchTimeRef.current && (now - lastFetchTimeRef.current < 30000)) {
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      console.log('Fetching user statistics...');
      const data = await apiService.fetchUserStatistics({ 
        user_id: userId, 
        language 
      });
      
      console.log('Stats fetched successfully:', data);
      setStats(data);
      lastFetchTimeRef.current = now;
    } catch (err) {
      console.error('Error fetching user statistics:', err);
      setError(err.message || 'Failed to fetch statistics');
    } finally {
      setLoading(false);
    }
  }, [userId, language]); // Now only depends on userId and language

  // Fetch stats on mount and when userId/language changes
  useEffect(() => {
    fetchStats();
  }, [fetchStats]); // Now safe to include fetchStats

  // Function to manually refresh stats (useful after completing exercises)
  const refreshStats = useCallback(() => {
    return fetchStats(true);
  }, [fetchStats]);

  const value = {
    stats,
    loading,
    error,
    refreshStats
  };

  return (
    <StatsContext.Provider value={value}>
      {children}
    </StatsContext.Provider>
  );
};

// Custom hook to use the stats context
export const useStats = () => {
  const context = useContext(StatsContext);
  if (context === undefined) {
    throw new Error('useStats must be used within a StatsProvider');
  }
  return context;
};